import React from "react";
import { Instagram, Twitter, Youtube } from "lucide-react";

const cols = [
  {
    title: "Product",
    links: ["How it works", "Filters", "Community", "FAQ"],
  },
  {
    title: "Company",
    links: ["About", "Press", "Careers", "Contact"],
  },
  {
    title: "Legal",
    links: ["Privacy", "Terms", "Safety", "Cookies"],
  },
];

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#070707] border-t border-white/5"
    >
      <div className="container mx-auto max-w-7xl px-6 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-2.5 h-2.5 rounded-full bg-[#C6FF00] shadow-[0_0_18px_#C6FF00]" />
              <span className="font-heading text-3xl tracking-wide text-white">
                SWOLE<span className="text-[#C6FF00]">MATES</span>
              </span>
            </div>
            <p className="text-sm text-neutral-400 max-w-sm leading-relaxed">
              The fitness dating app for partners who lift, run, and grow
              together. Built for the ones who actually show up.
            </p>
            <div className="flex gap-3 mt-8">
              {[
                { Icon: Instagram, label: "instagram" },
                { Icon: Twitter, label: "twitter" },
                { Icon: Youtube, label: "youtube" },
              ].map(({ Icon, label }, i) => (
                <a
                  key={label}
                  href="#"
                  data-testid={`social-link-${i}`}
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-neutral-400 hover:border-[#C6FF00] hover:text-[#C6FF00] transition-colors"
                  aria-label={label}
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          <div className="lg:col-span-7 grid grid-cols-3 gap-6">
            {cols.map((c) => (
              <div key={c.title}>
                <p className="text-xs uppercase tracking-[0.25em] text-neutral-500 font-semibold mb-5">
                  {c.title}
                </p>
                <ul className="flex flex-col gap-3">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a
                        href="#"
                        className="text-sm text-neutral-300 hover:text-[#C6FF00] transition-colors"
                      >
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-neutral-500">
            © {new Date().getFullYear()} Swolemates. Built for the strong.
          </p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-neutral-600">
            Made with <span className="text-[#C6FF00]">grit</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
